<template>
    <div>
        <b-list-group v-for="adjunto in listadoAdjEt" :key="adjunto.id">
            <b-list-group-item style="background:transparent;color:#000">
                <b-container class="bv-example-row" >
                    <b-row style="background:transparent;color:#000;font-size:10pt;">
                        <b-col>
                            <b-row><b>Tipo: </b></b-row>
                            <b-row>{{convertTipo(adjunto.tipo)}} </b-row>
                            <br>
                            <b-row><b>Idioma: </b></b-row>
                            <b-row>{{convertIdioma(adjunto.idioma)}} </b-row>
                        </b-col>
                        <b-col>
                            <b-row><span><b>Fecha ddasel documento:</b> {{adjunto.fecha}}</span></b-row>
                            <b-row><span><b>Fecha de vencimiento:</b> {{adjunto.fechavencimiento}}</span></b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col><b-button size="sm" variant="primary" @click="DescargarAdj(adjunto.adjunto);">Descargar </b-button></b-col>
                        <b-col>
                            <b-row>
                                <b-col>
                                    <b-button size="sm" variant="danger" v-if="selectedProductEt.finalizado == 0" title="Editar Adjunto" @click="deleteAdjunto(adjunto)"><span class="fa fa-trash fa-lg" style="color: black;"></span></b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row style="background:transparent;color:#fff;font-size:10pt;">
                        <b-col><b>{{adjunto.observacion}}</b></b-col>
                    </b-row>
                </b-container>
            </b-list-group-item>
        </b-list-group>

       

    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
    name:'ListadoAdjuntos',
    data: function(){
        return{

            editar: {
                id:'',
                idioma: null,
                tipo: null,
                estado_fds: null,
                cumple_decreto: 'NO',
                fecha: null,
                sistema: false,
                observacion: null,
                adjunto: null,
            }
        };
    },
    components: {
        
    },
    computed:{
       ...mapState('adjuntos_et', [
           'listadoAdjEt',
           'selectedAdjunto',
           'idiomas',
           'tipos',
           'estados_fds',
           'Actualiza',
           'adj'
        ]),
         ...mapState('productos_et',[
            'selectedProductEt'
        ]),  
    },
    methods:{
        async DescargarAdj(adj){
            window.open(process.env.VUE_APP_API_URL_ADJ + adj);
            //http://localhost:8000/repository/DiseneEt/FDS/2_FDS_20200531_154337.pdf
            //http://localhost:8000/storage/files/repository/FDS/27359_20190808_151916.PDF
        },
        ...mapActions('adjuntos', [
            'editaAdjunto',
            'getInfoAsignacion',
            'cambiaActivo'
        ]),
        ...mapActions('adjuntos_et', [
            'deleteAdjunto'
        ]),
        
        getAdjunto(e){
            //Asignamos la imagen a  nuestra data
           let file = e.target.files[0];
           this.selectedAdjunto.avatar = file
        },
        edit(adjunto){
            this.$refs.modal_edit_adj.show();
            this.editar.id = adjunto.id;
            this.editar.idioma = adjunto.idioma;
            this.editar.tipo = adjunto.tipo;
            this.editar.estado_fds = adjunto.estado_fds;
            this.editar.fecha = adjunto.fecha;
            this.editar.adjunto = this.selectedAdjunto.avatar;
            this.editar.observacion = adjunto.observacion;

            if(this.editar.estado_fds == 162){
                this.editar.cumple_decreto = "SI";
            }else{
                this.editar.cumple_decreto = "NO";
            }
        },
        editarAdj(){
            let formData = new FormData();

            formData.append("id", this.editar.id);
            formData.append("idioma", this.editar.idioma);
            formData.append("tipo", this.editar.tipo);
            formData.append("cumple_decreto", this.editar.cumple_decreto);
            formData.append("fecha", this.editar.fecha);
            formData.append("avatar", this.selectedAdjunto.avatar);
            formData.append("observacion", this.editar.observacion);

            this.editaAdjunto(formData);
            this.$refs.modal_edit_adj.hide();
        },
        asignar: function(id){
            let self = this;
            self.idAdj = null;
            self.idAdj = id;
            self.$refs.modal_asig_adj.show();
            this.selectedAdjunto.id_adjunto = id;
            this.getInfoAsignacion(id);
        },
        convertTipo(id){
            var tipo = "";

            switch (id) {
                case 154:
                    tipo = 'FDS';
                    break;
                case 155:
                    tipo = 'MSDS';
                    break;
                case 156:
                    tipo = 'ET';
                    break;
                case 157:
                    tipo = 'TE';
                    break;
                case 158:
                    tipo = 'AR';
                    break;
                case 159:
                    tipo = 'Otro';
                    break;
                case 177:
                    tipo = 'SDS';
                    break;
                default:
                    break;
            }

            return tipo;
        },
        convertIdioma(id){
            var idioma = "";

            switch (id) {
                case 137:
                    idioma = 'Español';
                    break;

                case 138:
                    idioma = 'Ingles';
                    break;

                case 139:
                    idioma = 'Portugues';
                    break;

                case 140:
                    idioma = 'Polaco';
                    break;

                case 142:
                    idioma = 'Aleman';
                    break;

                default:
                    break;
            }

            return idioma;
        }

    }
}
</script>
